// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-wrap {
    position: relative;
}
  
.tooltip-wrap:hover .tooltip {
    opacity: 1;
    pointer-events: all;
    transition-delay: 0.5s;
}
  
.tooltip-wrap .tooltip {
    transition: .3s;
    position: absolute;
    width: max-content;
    bottom: calc(100% + 10px);
    left: 0;
    opacity: 0;
    pointer-events: none;
}

.tooltip-ignore-hidden {
    position: relative;
}
  
.tooltip-ignore-hidden:hover .tooltip {
    opacity: 1;
    pointer-events: all;
    transition-delay: 0.5s;
}
  
.tooltip-ignore-hidden .tooltip {
    transition: .3s;
    position: fixed;
    width: max-content;
    opacity: 0;
    pointer-events: none;
}
  
.tooltip-ignore-hidden .tooltip-absolute{
    bottom: calc(100% + 40px);
    left: 0;
    position: absolute;
}

.tooltip {
    background-color: rgb(255, 250, 205);
    padding: 0.5em;
    color: #000;
    border: 1px solid black;
    position: absolute;
    z-index: 99999000;
    display: table;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/tooltip.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,OAAO;IACP,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".tooltip-wrap {\r\n    position: relative;\r\n}\r\n  \r\n.tooltip-wrap:hover .tooltip {\r\n    opacity: 1;\r\n    pointer-events: all;\r\n    transition-delay: 0.5s;\r\n}\r\n  \r\n.tooltip-wrap .tooltip {\r\n    transition: .3s;\r\n    position: absolute;\r\n    width: max-content;\r\n    bottom: calc(100% + 10px);\r\n    left: 0;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n.tooltip-ignore-hidden {\r\n    position: relative;\r\n}\r\n  \r\n.tooltip-ignore-hidden:hover .tooltip {\r\n    opacity: 1;\r\n    pointer-events: all;\r\n    transition-delay: 0.5s;\r\n}\r\n  \r\n.tooltip-ignore-hidden .tooltip {\r\n    transition: .3s;\r\n    position: fixed;\r\n    width: max-content;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n  \r\n.tooltip-ignore-hidden .tooltip-absolute{\r\n    bottom: calc(100% + 40px);\r\n    left: 0;\r\n    position: absolute;\r\n}\r\n\r\n.tooltip {\r\n    background-color: rgb(255, 250, 205);\r\n    padding: 0.5em;\r\n    color: #000;\r\n    border: 1px solid black;\r\n    position: absolute;\r\n    z-index: 99999000;\r\n    display: table;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
